import LocalStorageRepository from "../../../repository/LocalStorageRepository";
import PanelSettings from "../interface/MarketSettingLocalStorage";
import {set} from "lodash";
import MarketSetting from "../interface/MarketSettingLocalStorage";
import MarketCartLocalstorage from "../interface/MarketCartLocalstorage";
import RequestHandler from "../../../services/RequestHandler";
import MarketOrderLocalstorage from "../interface/MarketOrderLocalstorage";

export default class MarketRepository {

    static getSettingMarket(): PanelSettings {
        try {
            const defaultValue = JSON.stringify(MarketRepository.DefaultPanelSetting())
            const localStorage = LocalStorageRepository.get("setting", defaultValue)
            return JSON.parse(localStorage as string)
        } catch (e) {
            return this.DefaultPanelSetting();
        }
    }

    static async getSetting(shopId: string) {
        return await RequestHandler.get(`/shops/${shopId}`)
    }

    static getCartMarket() {
        try {
            const defaultValue = JSON.stringify(MarketRepository.DefaultCart())
            const localStorage = LocalStorageRepository.get("cart", defaultValue)
            return JSON.parse(localStorage as string)
        } catch (e) {
            return this.DefaultCart();
        }
    }

    static setSettingMarket(key: string, value: any) {
        const data = MarketRepository.getSettingMarket()
        set(data, key, value)
        LocalStorageRepository.set("setting", data)
    }

    static setCartMarket(key: string, value: any) {
        const data = MarketRepository.getCartMarket()
        set(data, key, value)
        LocalStorageRepository.set("cart", data)
    }

    static cartInit() {
        LocalStorageRepository.set("cart", this.getCartMarket())
    }

    static getOrdersMarket(): MarketOrderLocalstorage[] {
        try {
            const defaultValue = JSON.stringify(MarketRepository.DefaultOrders())
            const localStorage = LocalStorageRepository.get("orders", defaultValue)
            return JSON.parse(localStorage as string)
        } catch (e) {
            return this.DefaultOrders();
        }
    }

    static orderInit() {
        LocalStorageRepository.set("orders", this.getOrdersMarket())
    }

    private static DefaultPanelSetting(): MarketSetting {
        return {
            isList: false,
            id: "",
            logo: "",
            gridNumber: [1, 2, 3, 4, 5],
            grid: 3,
            colorArray: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
            color: 1,
            themeMode: "light",
            activeDesk: false,
            customBuy: false,
            receipt: 100,
            password: "",
            privateKey: process.env.REACT_APP_PRIVATE_KEY as string,
            publicKey: process.env.REACT_APP_PUBLIC_KEY as string,
            name: "",
            phone: "",
            textUnderBill: "",
            basicReceiptInvoice: 100,
            api_key: "",
            discount: [],
            printer: [],
            marketMode: "pos",
            paymentMode: "pos",
            setting: true,
            extraCosts: [],
            baseUrl: "http://localhost/HamiOrder",
            service: "netbee",
            publicKeyNetbee: process.env.REACT_APP_PUBLIC_NETBEE_KEY as string,
            desk: [],
            showQrCode:false,
        }
    }

    private static DefaultCart(): MarketCartLocalstorage {
        return {
            items: []
        }
    }

    private static DefaultOrders(): MarketOrderLocalstorage[] {
        return []
    }
}